import { render } from "./TrustedAIPublicSector.vue?vue&type=template&id=79fb967e"
import script from "./TrustedAIPublicSector.vue?vue&type=script&lang=js"
export * from "./TrustedAIPublicSector.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__